import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

/**
 * Rebranding 2026 · ScrollToTop
 *
 * Componente "headless" (renderizza null) montato una sola volta dentro
 * <Router>. Ogni volta che cambia il pathname della rotta, scrolla la finestra
 * in cima. Risolve il comportamento di react-router v5 che mantiene la
 * posizione di scroll precedente quando si naviga tra le pagine.
 *
 * Es. al click su "Modifica Pacchetto" (lista pratiche espansa, scroll in basso)
 * la pagina /edit-practice/:id si apre dall'alto.
 */
const ScrollToTop = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    try {
      window.scrollTo({top: 0, left: 0, behavior: 'auto'});
    } catch (e) {
      // Fallback per browser che non supportano l'options object
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
